import { Link } from "react-router-dom";
import { Button } from "../App.styles";

const LinkButton = (props) => {
  const { children, "data-testid": testId, gameId, ...btnProps } = props
  return (
    <Link data-testid={testId} to={props.to}>
      <Button {...btnProps}>
      {
        typeof children === "string"
          ? <div dangerouslySetInnerHTML={{ __html: children }} />
          : children
      }
      </Button>
    </Link>
  )
};

export default LinkButton;
